<!-- Copyright (C) 2025 by Posit Software, PBC. -->

<template>
  <h1 class="page-title">
    <slot />
  </h1>
</template>

<style lang="scss" scoped>
.page-title {
  font-size: 1.85rem;
  font-weight: 400;
  margin: 0.25rem 0 0.75rem;
  word-wrap: break-word;
}
</style>
